// extracted by mini-css-extract-plugin
export var button = "_z-1";
export var featuredLink = "_z-4";
export var spinner = "_z-2";
export var spinnerContainer = "_z-3";
export var text = "_z-0";